var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5879 7.19117C21.3575 6.33435 20.6819 5.65894 19.8252 5.42822C18.2602 5 11.9998 5 11.9998 5C11.9998 5 5.73963 5 4.17456 5.41199C3.33435 5.64246 2.64234 6.33448 2.41187 7.19117C2 8.75611 2 12.0016 2 12.0016C2 12.0016 2 15.2634 2.41187 16.812C2.64258 17.6687 3.31787 18.3441 4.17469 18.5749C5.75611 19.0032 12 19.0032 12 19.0032C12 19.0032 18.2602 19.0032 19.8252 18.5912C20.682 18.3606 21.3575 17.6852 21.5882 16.8285C21.9999 15.2634 21.9999 12.0181 21.9999 12.0181C21.9999 12.0181 22.0164 8.75611 21.5879 7.19117V7.19117ZM10.0066 14.9999V9.0033L15.2124 12.0016L10.0066 14.9999Z",
    fill: "#242424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d3a422b1.svg";
export { ForwardRef as ReactComponent };